import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingCTA from '../components/FloatingCTA';
import TeamMemberCard from '../components/TeamMemberCard';
import Button from '../components/Button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const UberUns = () => {
  return <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="section-padding bg-primary-brand text-white pt-32 relative overflow-hidden">
        <div className="container-custom text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-8">AMMING GmbH</h1>
          <p className="text-xl text-secondary-brand opacity-90">Bauen mit System. Denken in Lösungen.</p>
        </div>
      </section>

      {/* Company Story */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto fade-in-up">
            <h2 className="text-4xl font-bold text-primary-brand mb-12 text-center">Über uns</h2>
            <div className="space-y-8 text-lg text-gray-600 leading-relaxed">
              <p>Wir, Alen Mikic (Master of Engineering) und Almir Sisic (Diplom-Betriebswirt), haben gemeinsam die AMMING GmbH gegründet – mit dem Ziel, Bauprojekte kompetent, effizient und zuverlässig zum Erfolg zu führen.</p>
              <p>
                Mit über 20 Jahren Erfahrung im Raum München kennen wir die Herausforderungen am Bau – und die Lösungen dazu. Ob Rohbau, Sanierung oder schlüsselfertiges Bauen: Wir bringen Ihr Projekt sicher ins Ziel.
              </p>
              <p>
                Unsere besondere Stärke liegt in der Projekt-Bau-Organisation mit kleinen, eingespielten Teams. Das erlaubt uns kurze Wege, klare Kommunikation und flexible Abläufe – ohne Qualitätsverlust.
              </p>
              <p>
                Wir übernehmen Verantwortung – auch für anspruchsvolle oder unkonventionelle Vorhaben. Was andere abschreckt, sehen wir als Herausforderung.
              </p>
              <p>
                Ein klarer Fokus liegt auf dem energieeffizienten Bauen. Wir planen und begleiten Projekte nach KfW-40-Standard sowie Passivhauskonzepte – nachhaltig, wirtschaftlich und zukunftsfähig.
              </p>
              <p className="font-semibold text-primary-brand">
                Die AMMING GmbH steht für Verlässlichkeit, saubere Planung und partnerschaftliche Zusammenarbeit.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="section-padding bg-primary-brand text-white relative overflow-hidden">
        <div className="container-custom relative z-10">
          <div className="text-center mb-16 fade-in-up">
            <h2 className="text-4xl font-bold mb-6">Unser Team</h2>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Lernen Sie die Geschäftsführung der AMMING GmbH kennen – zwei Experten mit komplementären Fähigkeiten.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-5xl mx-auto stagger-children">
            <TeamMemberCard name="Alen Mikic" title="Master of Engineering" role="Geschäftsführer" phone="+49 157 7030 5796" email="am@amming.de" />
            <TeamMemberCard name="Almir Sisic" title="Diplomierter Betriebswirt" role="Kaufmännischer Projektleiter" phone="+49 179 758 8717" email="as@amming.de" />
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <div className="max-w-3xl mx-auto space-y-8 fade-in-up">
            <h2 className="text-4xl font-bold text-primary-brand">
              Ihre Idee = Unser Projekt
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Lassen Sie uns gemeinsam Ihre Bauträume verwirklichen. Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch.
            </p>
            <div className="pt-8">
              <Link to="/kontakt">
                <Button variant="primary" size="lg" icon={<ArrowRight className="w-5 h-5" />}>
                  Jetzt Kontakt aufnehmen
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingCTA />
    </div>;
};
export default UberUns;